import { NgModule } from '@angular/core';

import { PagesRoutingModule } from './pages-routing.module';
import { RossSharedModule } from 'src/@ross/shared.module';
import { LayoutModule } from '../shared/layout/layout.module';

import { PagesComponent } from './pages.component';
import { MainComponent } from './main/main.component';

import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AngularMaterialModule } from '../shared/angular-material.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import {MatStepperModule} from '@angular/material/stepper';


@NgModule({
  declarations: [
    PagesComponent,
    MainComponent
  ],
  imports: [
    PagesRoutingModule,
    RossSharedModule,
    LayoutModule,
    MatDialogModule,
    NgxSpinnerModule,
    AngularMaterialModule,
    MatIconModule,
    NgxDatatableModule,
    MatStepperModule
    
  ],
  providers: []
})
export class PagesModule { }


